module.exports = __webpack_public_path__ + "static/media/ambulance-helicopter-help-svgrepo-com.cf4df3d9.svg";